var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

// require('moment');
// require('bootstrap/js/dist/alert');
// require('bootstrap/js/dist/button');
// require('bootstrap/js/dist/carousel');
require('bootstrap/js/dist/collapse');
require('bootstrap/js/dist/dropdown');
require('bootstrap/js/dist/modal');
// require('bootstrap/js/dist/popover');
// require('bootstrap/js/dist/scrollspy');
// require('bootstrap/js/dist/tab');
// require('bootstrap/js/dist/tooltip');
// require('bootstrap/js/dist/util');

require('bootstrap-select');
require('pc-bootstrap4-datetimepicker');
// require('bootstrap-datepicker');

// require('jquery-sticky');
// require('@fortawesome/fontawesome-free');

require('owl.carousel');
require('owl.carousel2.thumbs');
require('magnific-popup');
require('lazysizes');
// require('picturefill');
lazySizes.init();

// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded

window.initProductSlider = (sliderEl, thumbnailEl) => {

    var slider = $(sliderEl);
    // reference for thumbnail items
    var thumbnailSlider = $(thumbnailEl);
    //transition time in ms
    var duration = 500;

    // carousel function for main slider
    slider.owlCarousel({
        loop: false,
        nav: false,
        dots: true,
        smartSpeed: 750,
        items: 1,
        responsive: {
            0: {

            },
            768: {
                dots: false,
                nav: false
            }
        }
    }).on('changed.owl.carousel', function(e) {
        //On change of main item to trigger thumbnail item
        thumbnailSlider.trigger('to.owl.carousel', [e.item.index, duration, true]);
    });

    // carousel function for thumbnail slider
    thumbnailSlider.owlCarousel({
        loop: false,
        center: false, //to display the thumbnail item in center
        nav: false,
        dots: true,
        smartSpeed: 750,
        margin: 5,
        responsive: {
            0: {
                items: 3
            },
            768: {
                items: 5
            }
        }
    }).on('click', '.owl-item', function() {
        // On click of thumbnail items to trigger same main item
        slider.trigger('to.owl.carousel', [$(this).index(), duration, true]);

    }).on('changed.owl.carousel', function(e) {
        // On change of thumbnail item to trigger main item
        slider.trigger('to.owl.carousel', [e.item.index, duration, true]);
    });

}

$(function() {

    // Initialise the Ajax funxctions - put most of your js calls in this function
    // or if you need to reload them after an ajax call
    // initAjaxJS();

    // Universal Analytics event tracking
    if (typeof ga !== 'undefined') {

        // track all phone number click events
        $('a[href^="tel:"]').on('click', function(e) {
            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        // track all email click events
        $('a[href^="mailto:"]').on('click', function(e) {

            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Email', 'click', value[1]);
        });

    }

    // $('.selectpicker').selectpicker();

    $('#login-modal').on('shown.bs.modal', function() {
        $('#email-login-modal').trigger('focus')
    })

    // Off canvas mobile nav
    $('.btn-menu').click(function() {
        $('.sidebar-offcanvas').toggleClass('active');
        $(this).toggleClass('btn-close');

    });


    if ($('#home-slider').length) {
        $('#home-slider').owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 0,
            responsiveClass: true,
            items: 1,
            nav: false,
            dot: true,
            autoplay: true,
            autoplayTimeout: 6000,
            smartSpeed: 750,
            // animateIn: 'fadeIn', // add this
            // animateOut: 'fadeOut'
        })
    }

    if ($('.brand-carousel').length) {
        $('.brand-carousel').owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 30,
            items: 1,
            nav: false,
            dot: true,
            autoplay: true,
            autoplayTimeout: 3000,
            smartSpeed: 750,
            responsive: {
                576: {
                    items: 2
                },
                768: {
                    items: 4
                },
                1200: {
                    items: 4
                }
            }
        })
    }

    $(window).scroll(function(event) {
        var scroll = $(window).scrollTop();
        // Do something
        if ($(this).scrollTop() > 50) {
            // alert('hello');
            $('.main-nav').addClass('shrink-nav');

        } else {
            $('.main-nav').removeClass('shrink-nav');
        }
        // if ($(this).scrollTop() > 320) {
        //     $('.nav-right-slide').addClass('onscreen');
        // } else {
        //     $('.nav-right-slide').removeClass('onscreen');
        // }
        // alert('hello');
    });

    // $('.scrollup').click(function() {
    //     $("html, body").animate({
    //         scrollTop: 0
    //     }, 600);
    //     return false;
    // });

    $('.popup').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        },
        disableOn: function() {
            if ($(window).width() < 600) {
                return false;
            }
            return true;
        }
    });


    // Mask emails from spammers
    // $('.mask-email').each(function() {
    //     var $email = $(this);
    //     var css = $email.attr('class');
    //     // var label = $email.attr('title');
    //     var address = $email.text().replace(/\s*\[at\]\s*/, '@').replace(/\s*\[dot\]\s*/g, '.');
    //     var query = $email.data('query'); // get query string parameters if present
    //     var params = "";
    //     if (query != null) {
    //         params = query;
    //     }
    //     $email.html('<a href="mailto:' + address + params + '" class="' + css + '">' + address + '</a>');
    //     // clear em out
    //     $email.attr('class', '');
    //     $email.attr('data-query', '');
    // });


    //tabbed url
    if (location.hash.substr(0, 2) == "#!") {
        $("a[href='#" + location.hash.substr(2) + "']").tab("show");
    }

    $("a[data-toggle='tab']").on("shown.bs.tab", function(e) {
        var hash = $(e.target).attr("href");
        if (hash.substr(0, 1) == "#") {
            location.replace("#!" + hash.substr(1));
        }
    });

    //dropdown inside dropdown
    $('.dropdown.dropdown-keep-open').on({
        'mouseleave': function() {
            this.closable = true;
        },
        'mouseenter': function() {
            this.closable = false;
        },
        'hide.bs.dropdown': function(e) {
            if ($(e.target).hasClass('dropdown-keep-open')) {
                return this.closable;
            }

            return true;
        },
    })

    $('.btn-cart').each(function() {
        var $this = $(this);
        var productId = $this.data('id');
        if (!productId) return;

        $this.on('click', function() {
            var event = new CustomEvent('product::updated', {
                detail: { product_id: productId },
            });
            document.dispatchEvent(event);
        })
    });

});